import { combineReducers } from "redux";
import workAreas from "./workAreas";
import graphics from "./graphics";
import charts from "./charts";
import nodes from "./nodes";
import toolbar from "./toolbar";

const engineering = combineReducers({
  workAreas,
  graphics,
  charts,
  nodes,
  toolbar
});

export default engineering;
